import { AccountSecurityPage } from '../AccountSecurityPage';

/**
 * Customer portal account security.
 * Reuses the polished AccountSecurityPage with portal header/breadcrumb variants.
 */
export function CustomerPortalAccountSecurityPage() {
  return <AccountSecurityPage variant="portal" />;
}
